import React, { useEffect, useState } from "react";
import { Box, Paper, Typography, Grid, Button, Divider } from "@mui/material";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import FormInput from "../inputs/FormInput";
import TextEditor from "../inputs/TextEditor";
import LanguageToggle from "../global/LanguageToggle";

const FormAgencySection = ({ currentData, onSubmit, isLoading }) => {
    console.log("🚀 ~ FormAgencySection ~ currentData:", currentData)
    const { i18n } = useTranslation();
    const lng = i18n.language || "en";
    const isArabic = lng.startsWith("ar");
    const initialLang = localStorage.getItem("i18nextLng") || i18next.language || "ar";
    const [activeLang, setActiveLang] = useState(initialLang.startsWith("ar") ? "ar" : "en");

    // Home Section
    const [homeTitleAr, setHomeTitleAr] = useState("");
    const [homeTitleEn, setHomeTitleEn] = useState("");
    const [homeSubTitleAr, setHomeSubTitleAr] = useState("");
    const [homeSubTitleEn, setHomeSubTitleEn] = useState("");
    const [homeDescriptionAr, setHomeDescriptionAr] = useState("");
    const [homeDescriptionEn, setHomeDescriptionEn] = useState("");

    // Page Section
    const [pageNameAr, setPageNameAr] = useState("");
    const [pageNameEn, setPageNameEn] = useState("");
    const [headerImage, setHeaderImage] = useState(null);
    console.log("🚀 ~ FormAgencySection ~ headerImage:", headerImage)
    const [pageTitleAr, setPageTitleAr] = useState("");
    const [pageTitleEn, setPageTitleEn] = useState("");
    const [pageSubTitleAr, setPageSubTitleAr] = useState("");
    const [pageSubTitleEn, setPageSubTitleEn] = useState("");
    const [pageDescriptionAr, setPageDescriptionAr] = useState("");
    const [pageDescriptionEn, setPageDescriptionEn] = useState("");

    useEffect(() => {
        if (currentData) {
            const home = currentData?.home || {};
            const page = currentData?.page || {};
            const header = page?.header || {};
            const section = page?.section || {};

            setHomeTitleAr(home?.title?.ar || "");
            setHomeTitleEn(home?.title?.en || "");
            setHomeSubTitleAr(home?.sub_title?.ar || "");
            setHomeSubTitleEn(home?.sub_title?.en || "");
            setHomeDescriptionAr(home?.description?.ar || "");
            setHomeDescriptionEn(home?.description?.en || "");

            setPageNameAr(header?.page_name?.ar || "");
            setPageNameEn(header?.page_name?.en || "");
            setHeaderImage(header?.image || null);

            setPageTitleAr(section?.title?.ar || "");
            setPageTitleEn(section?.title?.en || "");
            setPageSubTitleAr(section?.sub_title?.ar || "");
            setPageSubTitleEn(section?.sub_title?.en || "");
            setPageDescriptionAr(section?.description?.ar || "");
            setPageDescriptionEn(section?.description?.en || "");
        }
    }, [currentData]);

    const getImageName = (imageVal) => {
        if (!imageVal) return "";
        if (typeof imageVal === 'string') {
            return imageVal.substr(imageVal.lastIndexOf('/') + 1);
        }
        return imageVal;
    };

    const handleHeaderImageChange = (e) => {
        setHeaderImage(e.target.value);
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const payload = {
            home: {
                title: {
                    ar: homeTitleAr || homeTitleEn,
                    en: homeTitleEn || homeTitleAr,
                },
                sub_title: {
                    ar: homeSubTitleAr || homeSubTitleEn,
                    en: homeSubTitleEn || homeSubTitleAr,
                },
                description: {
                    ar: homeDescriptionAr || homeDescriptionEn,
                    en: homeDescriptionEn || homeDescriptionAr,
                },
            },
            page: {
                header: {
                    page_name: {
                        ar: pageNameAr || pageNameEn,
                        en: pageNameEn || pageNameAr,
                    },
                    image: getImageName(headerImage),
                },
                section: {
                    title: {
                        ar: pageTitleAr || pageTitleEn,
                        en: pageTitleEn || pageTitleAr,
                    },
                    sub_title: {
                        ar: pageSubTitleAr || pageSubTitleEn,
                        en: pageSubTitleEn || pageSubTitleAr,
                    },
                    description: {
                        ar: pageDescriptionAr || pageDescriptionEn,
                        en: pageDescriptionEn || pageDescriptionAr,
                    },
                },
            },
        };

        onSubmit(payload);
    };

    return (
        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 3 }}>
            {/* ===== Home Section ===== */}
            <Paper sx={{ p: 3, borderRadius: 2 }}>
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2, flexWrap: "wrap", gap: 2 }}>
                    <Typography variant="h6">
                        {isArabic ? "قسم الصفحة الرئيسية" : "Home Section"}
                    </Typography>
                    <LanguageToggle activeLang={activeLang} onChange={(lng) => setActiveLang(lng)} showLabel={true} />
                </Box>

                <Grid container spacing={3}>
                    {activeLang === "ar" && (
                        <Grid item xs={12} md={6}>
                            <FormInput
                                label="العنوان (عربي)"
                                placeholder="أدخل العنوان بالعربي"
                                value={homeTitleAr}
                                onChange={(e) => setHomeTitleAr(e.target.value)}
                                fullWidth
                            />
                        </Grid>
                    )}
                    {activeLang === "en" && (
                        <Grid item xs={12} md={6}>
                            <FormInput
                                label="Title (English)"
                                placeholder="Enter title in English"
                                value={homeTitleEn}
                                onChange={(e) => setHomeTitleEn(e.target.value)}
                                fullWidth
                            />
                        </Grid>
                    )}

                    {activeLang === "ar" && (
                        <Grid item xs={12} md={6}>
                            <FormInput
                                label="العنوان الفرعي (عربي)"
                                placeholder="أدخل العنوان الفرعي بالعربي"
                                value={homeSubTitleAr}
                                onChange={(e) => setHomeSubTitleAr(e.target.value)}
                                fullWidth
                            />
                        </Grid>
                    )}
                    {activeLang === "en" && (
                        <Grid item xs={12} md={6}>
                            <FormInput
                                label="Sub Title (English)"
                                placeholder="Enter sub title in English"
                                value={homeSubTitleEn}
                                onChange={(e) => setHomeSubTitleEn(e.target.value)}
                                fullWidth
                            />
                        </Grid>
                    )}

                    {activeLang === "ar" && (
                        <Grid item xs={12}>
                            <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 500 }}>
                                الوصف (عربي)
                            </Typography>
                            <TextEditor
                                name="home_description_ar"
                                value={homeDescriptionAr}
                                onChange={(e) => setHomeDescriptionAr(e.target.value)}
                                placeholder="أدخل الوصف بالعربي"
                            />
                        </Grid>
                    )}
                    {activeLang === "en" && (
                        <Grid item xs={12}>
                            <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 500 }}>
                                Description (English)
                            </Typography>
                            <TextEditor
                                name="home_description_en"
                                value={homeDescriptionEn}
                                onChange={(e) => setHomeDescriptionEn(e.target.value)}
                                placeholder="Enter description in English"
                            />
                        </Grid>
                    )}
                </Grid>
            </Paper>

            {/* ===== Page Section ===== */}
            <Paper sx={{ p: 3, borderRadius: 2, mt: 3 }}>
                <Typography variant="h6" sx={{ mb: 2 }}>
                    {isArabic ? "قسم الصفحة" : "Page Section"}
                </Typography>

                <Grid container spacing={3}>
                    {/* Header Image */}
                    <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                        <FormInput
                            type="file"
                            name="header_image"
                            labelImage={isArabic ? "صورة الهيدر" : "Header Image"}
                            value={headerImage}
                            onChange={handleHeaderImageChange}
                            width={200}
                            height={120}
                        />
                    </Grid>

                    {/* Page Name */}
                    {activeLang === "ar" && (
                        <Grid item xs={12} md={6}>
                            <FormInput
                                label="اسم الصفحة (عربي)"
                                placeholder="أدخل اسم الصفحة بالعربي"
                                value={pageNameAr}
                                onChange={(e) => setPageNameAr(e.target.value)}
                                fullWidth
                            />
                        </Grid>
                    )}
                    {activeLang === "en" && (
                        <Grid item xs={12} md={6}>
                            <FormInput
                                label="Page Name (English)"
                                placeholder="Enter page name in English"
                                value={pageNameEn}
                                onChange={(e) => setPageNameEn(e.target.value)}
                                fullWidth
                            />
                        </Grid>
                    )}

                    <Grid item xs={12}>
                        <Divider />
                        <Typography variant="subtitle1" sx={{ mt: 2, mb: 1, fontWeight: 600 }}>
                            {isArabic ? "بيانات القسم" : "Section Data"}
                        </Typography>
                    </Grid>

                    {activeLang === "ar" && (
                        <Grid item xs={12} md={6}>
                            <FormInput
                                label="العنوان (عربي)"
                                placeholder="أدخل العنوان بالعربي"
                                value={pageTitleAr}
                                onChange={(e) => setPageTitleAr(e.target.value)}
                                fullWidth
                            />
                        </Grid>
                    )}
                    {activeLang === "en" && (
                        <Grid item xs={12} md={6}>
                            <FormInput
                                label="Title (English)"
                                placeholder="Enter title in English"
                                value={pageTitleEn}
                                onChange={(e) => setPageTitleEn(e.target.value)}
                                fullWidth
                            />
                        </Grid>
                    )}

                    {activeLang === "ar" && (
                        <Grid item xs={12} md={6}>
                            <FormInput
                                label="العنوان الفرعي (عربي)"
                                placeholder="أدخل العنوان الفرعي بالعربي"
                                value={pageSubTitleAr}
                                onChange={(e) => setPageSubTitleAr(e.target.value)}
                                fullWidth
                            />
                        </Grid>
                    )}
                    {activeLang === "en" && (
                        <Grid item xs={12} md={6}>
                            <FormInput
                                label="Sub Title (English)"
                                placeholder="Enter sub title in English"
                                value={pageSubTitleEn}
                                onChange={(e) => setPageSubTitleEn(e.target.value)}
                                fullWidth
                            />
                        </Grid>
                    )}

                    {activeLang === "ar" && (
                        <Grid item xs={12}>
                            <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 500 }}>
                                الوصف (عربي)
                            </Typography>
                            <TextEditor
                                name="page_description_ar"
                                value={pageDescriptionAr}
                                onChange={(e) => setPageDescriptionAr(e.target.value)}
                                placeholder="أدخل الوصف بالعربي"
                            />
                        </Grid>
                    )}
                    {activeLang === "en" && (
                        <Grid item xs={12}>
                            <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 500 }}>
                                Description (English)
                            </Typography>
                            <TextEditor
                                name="page_description_en"
                                value={pageDescriptionEn}
                                onChange={(e) => setPageDescriptionEn(e.target.value)}
                                placeholder="Enter description in English"
                            />
                        </Grid>
                    )}
                </Grid>
            </Paper>

            <Box sx={{ mt: 3, display: 'flex', gap: 2 }}>
                <Button
                    type="submit"
                    variant="contained"
                    disabled={isLoading}
                    sx={{ minWidth: 120 }}
                >
                    {isLoading ? (isArabic ? "جاري الحفظ..." : "Saving...") : (isArabic ? "حفظ" : "Save")}
                </Button>
            </Box>
        </Box>
    );
};

export default FormAgencySection;
